const font = {
    fontFamily: 'Open Sans, Arial, sans-serif',
    fontWeight: 400,
};

export const styles = {
    input: {
        position: 'absolute',
        width: 1,
        height: 1,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
    },
    tag: {
        width: 'fit-content',
        padding: [3, 8],
        display: 'flex',
        alignItems: 'center',
        fontWeight: 400,
        fontSize: '12px',
        color: '#222222',
        textAlign: 'center',
        background: 'white',
        border: '1px solid',
        borderRadius: 4,
        cursor: 'pointer',
        transition: 'all 0.3s',

        ['&:hover']: {
            color: 'black',
            borderColor: 'rgb(122 122 122)',
        },
    },
    tagActive: {
        color: 'white',
        background: '#3D95FB',
        borderColor: '#3D95FB',
    },
    label: {
        marginRight: 8,
        marginBottom: 10,
        display: 'flex',
        fontSize: '14px',
        cursor: 'pointer',
        ...font,

        [`&:last-child`]: {
            marginRight: 0,
        },
    },
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
